import {inject, Injectable} from '@angular/core';
import { Observable, catchError, map, throwError } from 'rxjs';
import { llm_assembly_trascription_service } from './assemblyai.spench_recognition.service';
import { SnackbarService } from '@serv/snackbar.service';
import { PlayMessageService } from '@llm/service/play_message.service';
import {Tools_aiConsoleService} from "@llm/service/tools_ai-console.service";

/**
 * @Injectable
 * Proporcionado en el root de la aplicación.
 * Este servicio actúa como una fachada para transcribir audio.
 * Orquesta la llamada a un servicio de transcripción de bajo nivel (llm_assembly_trascription_service),
 * maneja las respuestas exitosas y los errores, y proporciona feedback al usuario a través de otros servicios.
 */
@Injectable({ providedIn: 'root' })
export class AudioTranscriptionService {
  //Injectables
  private _console = inject(Tools_aiConsoleService);

  /**
   * @constructor
   * @param {llm_assembly_trascription_service} llmAssemblyTrascriptionService - El servicio que realiza la comunicación directa con la API de transcripción.
   * @param {SnackbarService} snackbarService - Servicio para mostrar notificaciones visuales (actualmente comentado en el código).
   * @param {PlayMessageService} playMessageService - Servicio para reproducir mensajes de audio como feedback al usuario.
   */
  constructor(
    private llmAssemblyTrascriptionService: llm_assembly_trascription_service ,
    private snackbarService: SnackbarService,
    private playMessageService: PlayMessageService
  ) {}

  /**
   * Transcribe un blob de audio a texto.
   * Valida el blob de entrada, llama al servicio de transcripción, procesa la respuesta
   * y maneja los errores que puedan ocurrir durante el proceso.
   *
   * @param {Blob} audioBlob - El objeto Blob que contiene el audio a transcribir.
   * @returns {Observable<string>} Un observable que emite el texto de la transcripción si es exitosa,
   * o emite un error en caso contrario.
   */
  transcribeAudio(audioBlob: Blob): Observable<string> {
    if (!audioBlob || audioBlob.size === 0) {
      return throwError(() => new Error("Blob de audio vacío"));
    }
    return this.llmAssemblyTrascriptionService.transcriptAudio(audioBlob).pipe(
      map(transcript => {
        if (transcript.text?.trim() && transcript.text !== '[Não foi reconhecido texto]') {
          return transcript.text;
        } else {
           this._console.log(transcript)
          throw new Error("Transcripción vacía o no reconocida", transcript);
        }
      }),
      catchError(err => {
        this._console.error('Error en transcripción:', err);
        this.playMessageService.playMessage("Error al transcribir el audio").finally(()=>{
        });
        return throwError(() => err);
      })
    );
  }
}
